import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import FullScreenLoader from "./FullScreenLoader";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  // User passed directly from AuthCallback/LoginPage — skip the server round-trip
  if (location.state?.user) return children;
  if (user === null) return <FullScreenLoader label="Verifying your session" />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
